import Box from '@mui/material/Box';
import { ReactNode } from 'react';
import { useTheme } from '@mui/material/styles';

export type FlatListProps<T> = {
  data: T[];
  keyExtractor: (id: T) => string | number;
  renderComponent: (props: T) => ReactNode;
  dir?: 'row' | 'column';
  gap?: number | string;
  divider?: boolean;
  showDividerOnLastItem?: boolean;
};

export function FlatList<T>({
  data,
  keyExtractor,
  renderComponent,
  dir = 'column',
  gap = 0,
  divider = false,
}: FlatListProps<T>) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: dir,
        flexWrap: 'wrap',
        gap,
      }}
    >
      {data.map((el, index) => (
        <Box
          key={keyExtractor(el)}
          sx={{
            borderTop: index === 0 && divider ? `unset` : '1px solid',
            borderImage: theme.palette.rarityBackground.common,
            borderImageSlice: 1,
          }}
        >
          <>{renderComponent(el)}</>
        </Box>
      ))}
    </Box>
  );
}
